import React, {Suspense, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { Canvas } from '@react-three/fiber';
import EarthFiber from './components/Earth/EarthFiber';
import { IconButton } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import MySQL from './components/DataConnector/MySQL';
import {get, API_URL} from './utils/API';
import Display from './components/Display/Display';
import ShowDisplay from './components/Display/ShowDisplay';
import Filter from './components/Filter/Filter';
import LoadingScreen from './components/LoadingScreen/LoadingScreen'
import { useDispatch, useSelector } from 'react-redux';
import DataConnector from './components/DataConnector/MySQL';

export default function App() {
  const [sql, setSql] = useState(false)
  const [rendering, setRendering] = useState(true)
  const [query, setQuery] = useState("")
  const [display, setDisplay] = useState(false)
  const [metadatas, setMetadatas] = useState(null)
  const [nodeData, setNodeData] = useState(null)
  const [z, setZ] = useState(0)

  function openConnector() {
    setSql(true)
  }
/*
  useEffect(() => {
    console.log(metadatas)
  }, [metadatas])
*/
  useEffect(() => {
    if (rendering) {
      setZ(-1)
    } else {
      setZ(0)
    }
  }, [rendering])

  
  return (
        <div>
        {display ?
            <div className="container-fluid">
              <div className="row">
                <div className='col-6'>
                  <Display setDisplay={setDisplay} nodeData={nodeData}/> 
                </div>
              </div>
              
            </div>
            : sql ? null : <ShowDisplay setDisplay={setDisplay}/>}
        {rendering && <LoadingScreen className="loading-screen-layer"/>}
        
         <div className='fiber' style={{zIndex: z}}> 
         
         <div className="button-group">
              <IconButton icon={<img src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/512/external-database-100-most-used-icons-flaticons-lineal-color-flat-icons.png" width={35} height={35}/>} placement="middle" onClick={() => openConnector()}>  Connection</IconButton>
            </div>
          {/*   <div className='filter-group'>
                <Filter sqlInfo={sqlInfo} setSqlInfo={setSqlInfo} setMetadatas={setMetadatas} setRendering={setRendering}></Filter>
            </div>
            */}
           
            <div className='filter-group-test'>
                <Filter setMetadatas={setMetadatas} setRendering={setRendering} sql={sql}></Filter>
            </div>

            
            

            {sql ? <DataConnector sql={sql} setSql={setSql}/> : null}
          
            <Canvas camera={{position: [0, 0, 2.5] }}>
                  <EarthFiber metadatas={metadatas} setNodeData={setNodeData} query={query} setRendering={setRendering}/>
            </Canvas>
    
          </div>
          
          </div>
          );
};
